import script from "./RegistrationInquiryTemplatesComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationInquiryTemplatesComponent.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationInquiryTemplatesComponent.vue?vue&type=style&index=0&id=71a9d89e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a9d89e"]])

export default __exports__